/** Full clean: strips leading/trailing hyphens. Use on form submit or blur. */
export function slugify(s: string, maxLen = 60): string {
  return s
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, maxLen);
}

/** Permissive clean: allows trailing hyphens so users can type "emma-jansen". Use on every keystroke. */
export function cleanSlugInput(s: string, maxLen = 60): string {
  return s
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, "")
    .replace(/--+/g, "-")
    .replace(/^-/, "")
    .slice(0, maxLen);
}
